import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const ComponentWrapper = styled.section`
  display: block;
`

export const Heading = styled.h3`
  font-size: 18px;
  font-weight: bold;
  color: ${o => o.theme.color.deprecated.obsidian};
  padding: 0;
  margin-top: 0;
  margin-bottom: 20px;
  line-height: 1.5;
`

export const Label = styled.li`
  padding: 0;
  margin: 0;

  display: block;
  width: 100%;
  text-align: center;

  ${TypeStyle.css.bodyNano};
  color: ${o => o.theme.color.deprecated.obsidianLighter};

  &:first-child {
    text-align: left;
  }
  &:last-child {
    text-align: right;
  }
`

export const LabelsWrapper = styled.ul`
  padding: 0;
  margin: 7px 0 0;
  list-style: none;

  position: relative;

  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
`
